// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3LnF1","errorLogs":"EditorFooter_errorLogs__23psZ"};